import React from "react";

function MinusButton() {
  return (
    <>
      <div className="bg-[#f0f2f7] p-1 mb-3 h-8 w-8 flex justify-center items-center cursor-pointer rounded-3">
        <img src="/images/-.svg" className="w-5 h-5" alt="" />
      </div>
    </>
  );
}

export default MinusButton;
